/** External **/

/** Internal **/
import ACLStore from "lib/aclStore";
import {
  USER_TYPE_ENUM,
  ENGAGEMENT_ANALYTICS,
  PERFORMANCE_ANALYTICS,
  BEHAVIOUR_ANALYTICS,
  MODULE_USAGE_ANALYTICS,
  ATTENDANCE_ANALYTICS,
  YEARGROUP_PERFORMANCE,
  SUBJECT_PERFORMANCE,
  CLASS_PERFORMANCE,
  STAFF_PERFORMANCE,
  STUDENT_PERFORMANCE,
  OVERVIEW_BEHAVIOUR,
  CATEGORY_BEHAVIOUR,
  GRADE_BEHAVIOUR,
  STUDENT_BEHAVIOUR,
  OVERVIEW_USAGE,
  PLANNING_USAGE,
  PORTFOLIO_USAGE,
  ASSIGNMENTS_USAGE,
  MESSAGING_USAGE,
  ANNOUNCEMENTS_USAGE,
  IB_GRADE_THRESHOLD_CONFIG,
  IBDP_TOTAL_THRESHOLD_CONFIG,
  IBMYP_TOTAL_THRESHOLD_CONFIG,
  SCORE_THRESHOLD_CONFIG,
  LEARNING_COURSE_PERFORMANCE,
  CRITERIA_GRADE_THRESHOLD_CONFIG,
} from "./ToddleAnalyticsConstants";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
} from "Constants/stringConstants";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";

const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

//Table constants for engagement analytics module
export const STAFF_ENGAGEMENT_TABLE = "STAFF_ENGAGEMENT_TABLE";
export const STUDENT_ENGAGEMENT_TABLE = "STUDENT_ENGAGEMENT_TABLE";
export const FAMILY_ENGAGEMENT_TABLE = "FAMILY_ENGAGEMENT_TABLE";

// Table constants for performance analytics module
export const OVERALL_PERFORMANCE_BY_YEARGROUP =
  "OVERALL_PERFORMANCE_BY_YEARGROUP";
export const STUDENT_OVERALL_PERFORMANCE_BY_YEARGOUP =
  "STUDENT_OVERALL_PERFORMANCE_BY_YEARGOUP";
export const STUDENT_SUBJECTWISE_PERFORMANCE_BY_YEARGROUP =
  "STUDENT_SUBJECTWISE_PERFORMANCE_BY_YEARGROUP";
export const SUBJECT_PERFORMANCE_BY_YEARGROUP =
  "SUBJECTS_PERFORMANCE_BY_YEARGROUP";

export const OVERALL_PERFORMANCE_BY_SUBJECT = "OVERALL_PERFORMANCE_BY_SUBJECT";
export const STUDENT_PERFORMANCE_BY_SUBJECT = "STUDENT_PERFORMANCE_BY_SUBJECT";
export const CLASS_PERFORMANCE_BY_SUBJECT = "CLASSE_PERFORMANCE_BY_SUBJECT";

export const OVERALL_PERFORMANCE_BY_CLASS = "OVERALL_PERFORMANCE_BY_CLASS";
export const STUDENT_PERFORMANCE_BY_CLASS = "STUDENT_PERFORMANCE_BY_CLASS";
export const ASSIGNMENT_PERFORMANCE_BY_CLASS =
  "ASSIGNMENT_PERFORMANCE_BY_CLASS";

export const OVERALL_PERFORMANCE_BY_STAFF = "OVERALL_PERFORMANCE_BY_STAFF";
export const CLASS_PERFORMANCE_BY_STAFF = "CLASS_PERFORMANCE_BY_STAFF";

export const OVERALL_PERFORMANCE_BY_STUDENT = "OVERALL_PERFORMANCE_BY_STUDENT";
export const SUBJECT_PERFORMANCE_BY_STUDENT = "SUBJECT_PERFORMANCE_BY_STUDENT";
export const ASSIGNMENT_PERFORMANCE_BY_STUDENT =
  "ASSIGNMENT_PERFORMANCE_BY_STUDENT";

export const OVERALL_PERFORMANCE_BY_LEARNING_COURSE =
  "OVERALL_PERFORMANCE_BY_LEARNING_COURSE";
export const STUDENT_PERFORMANCE_BY_LEARNING_COURSE =
  "STUDENT_PERFORMANCE_BY_LEARNING_COURSE";
export const CLASS_PERFORMANCE_BY_LEARNING_COURSE =
  "CLASS_PERFORMANCE_BY_LEARNING_COURSE";

// Table constants for behaviour analytics module
export const STUDENT_NEGATIVE_NEUTRAL_INCIDENTS_OVERVIEW =
  "STUDENT_NEGATIVE_NEUTRAL_INCIDENTS_OVERVIEW";
export const STUDENT_POSITIVE_INCIDENTS_OVERVIEW =
  "STUDENT_POSITIVE_INCIDENTS_OVERVIEW";

export const INCIDENT_OVERVIEW_BY_CATEGORY = "INCIDENT_OVERVIEW_BY_CATEGORY";
export const INCIDENT_DETAILED_BY_CATEGORY = "INCIDENT_DETAILED_BY_CATEGORY";

export const INCIDENT_OVERVIEW_BY_GRADE = "INCIDENT_OVERVIEW_BY_GRADE";
export const INCIDENT_DETAILED_BY_GRADE = "INCIDENT_DETAILED_BY_GRADE";

export const INCIDENT_OVERVIEW_BY_STUDENT = "INCIDENT_OVERVIEW_BY_STUDENT";
export const INCIDENT_DETAILED_BY_STUDENT = "INCIDENT_DETAILED_BY_STUDENT";

const INCIDENT_TABLE_DEFAULT_COLUMNS = [
  "uid",
  "status",
  "category",
  "incidentName",
  "subCategory",
  "location",
  "sharedWith",
  "actions",
  "level",
  "incidentOccuredAt",
  "incidentModifiedTime",
  "createdBy",
  "incidentTime",
];

const PLANNING_USAGE_LEARNING_COURSE_DEFAULT_COLUMNS = [
  "learningCourse",
  "programmes",
  "grade",
  "transdisciplinaryUnitsCreated",
  "subjectSpecificUnitsCreated",
  "interdisciplinaryUnitsCreated",
  "unitPlansCreated",
];

const getV2SpecificAssignmentTableColumnIds = () => {
  return checkIsRevampPermEnabled()
    ? ["highestScore", "median", "lowestScore"]
    : [];
};

export const checkIsRevampPermEnabled = () => {
  return ACLStore.can("FeatureFlag:PerformanceAnalyticsRevamp");
};

//remove these both functions while deprecating the perm PerformanceAnalyticsRevamp

//Table constants for usage insights module
export const OVERVIEW_USAGE_BY_GRADE = "OVERVIEW_USAGE_BY_GRADE";
export const OVERVIEW_USAGE_BY_LEARNING_COURSE =
  "OVERVIEW_USAGE_BY_LEARNING_COURSE";
export const OVERVIEW_USAGE_BY_CLASS = "OVERVIEW_USAGE_BY_CLASS";
export const OVERVIEW_USAGE_BY_STAFF = "OVERVIEW_USAGE_BY_STAFF";
export const OVERVIEW_USAGE_BY_STUDENT = "OVERVIEW_USAGE_BY_STUDENT";
export const OVERVIEW_USAGE_BY_FAMILY = "OVERVIEW_USAGE_BY_FAMILY";

const OVERVIEW_USAGE_TABLES = {
  OVERVIEW_USAGE_BY_GRADE,
  OVERVIEW_USAGE_BY_CLASS,
  OVERVIEW_USAGE_BY_STAFF,
  OVERVIEW_USAGE_BY_LEARNING_COURSE,
  OVERVIEW_USAGE_BY_STUDENT,
  OVERVIEW_USAGE_BY_FAMILY,
};

export const PLANNING_USAGE_BY_GRADE = "PLANNING_USAGE_BY_GRADE";
export const PLANNING_USAGE_BY_CLASS = "PLANNING_USAGE_BY_CLASS";
export const PLANNING_USAGE_BY_STAFF = "PLANNING_USAGE_BY_STAFF";
export const PLANNING_USAGE_BY_LEARNING_COURSE =
  "PLANNING_USAGE_BY_LEARNING_COURSE";

const PLANNING_USAGE_TABLES = {
  PLANNING_USAGE_BY_GRADE,
  PLANNING_USAGE_BY_CLASS,
  PLANNING_USAGE_BY_STAFF,
  PLANNING_USAGE_BY_LEARNING_COURSE,
};

export const PORTFOLIO_USAGE_BY_GRADE = "PORTFOLIO_USAGE_BY_GRADE";
export const PORTFOLIO_USAGE_BY_CLASS = "PORTFOLIO_USAGE_BY_CLASS";
export const PORTFOLIO_USAGE_BY_STAFF = "PORTFOLIO_USAGE_BY_STAFF";
export const PORTFOLIO_USAGE_BY_STUDENT = "PORTFOLIO_USAGE_BY_STUDENT";
export const PORTFOLIO_USAGE_BY_LEARNING_COURSE =
  "PORTFOLIO_USAGE_BY_LEARNING_COURSE";

const PORTFOLIO_USAGE_TABLES = {
  PORTFOLIO_USAGE_BY_GRADE,
  PORTFOLIO_USAGE_BY_CLASS,
  PORTFOLIO_USAGE_BY_STAFF,
  PORTFOLIO_USAGE_BY_STUDENT,
  PORTFOLIO_USAGE_BY_LEARNING_COURSE,
};

export const ASSIGNMENTS_USAGE_BY_GRADE = "ASSIGNMENTS_USAGE_BY_GRADE";
export const ASSIGNMENTS_USAGE_BY_CLASS = "ASSIGNMENTS_USAGE_BY_CLASS";
export const ASSIGNMENTS_USAGE_BY_STAFF = "ASSIGNMENTS_USAGE_BY_STAFF";
export const ASSIGNMENTS_USAGE_BY_STUDENT = "ASSIGNMENTS_USAGE_BY_STUDENT";
export const ASSIGNMENTS_USAGE_BY_LEARNING_COURSE =
  "ASSIGNMENTS_USAGE_BY_LEARNING_COURSE";

const ASSIGNMENTS_USAGE_TABLES = {
  ASSIGNMENTS_USAGE_BY_GRADE,
  ASSIGNMENTS_USAGE_BY_CLASS,
  ASSIGNMENTS_USAGE_BY_STAFF,
  ASSIGNMENTS_USAGE_BY_STUDENT,
  ASSIGNMENTS_USAGE_BY_LEARNING_COURSE,
};

export const MESSAGING_USAGE_BY_STAFF = "MESSAGING_USAGE_BY_STAFF";
export const MESSAGING_USAGE_BY_STUDENT = "MESSAGING_USAGE_BY_STUDENT";
export const MESSAGING_USAGE_BY_FAMILY = "MESSAGING_USAGE_BY_FAMILY";

const MESSAGING_USAGE_TABLES = {
  MESSAGING_USAGE_BY_STAFF,
  MESSAGING_USAGE_BY_STUDENT,
  MESSAGING_USAGE_BY_FAMILY,
};

export const ANNOUNCEMENTS_USAGE_BY_GRADE = "ANNOUNCEMENTS_USAGE_BY_GRADE";
export const ANNOUNCEMENTS_USAGE_BY_CLASS = "ANNOUNCEMENTS_USAGE_BY_CLASS";
export const ANNOUNCEMENTS_USAGE_BY_STAFF = "ANNOUNCEMENTS_USAGE_BY_STAFF";
export const ANNOUNCEMENTS_USAGE_BY_STUDENT = "ANNOUNCEMENTS_USAGE_BY_STUDENT";
export const ANNOUNCEMENTS_USAGE_BY_FAMILY = "ANNOUNCEMENTS_USAGE_BYF_FAMILY";

const ANNOUNCEMENTS_USAGE_TABLES = {
  ANNOUNCEMENTS_USAGE_BY_GRADE,
  ANNOUNCEMENTS_USAGE_BY_CLASS,
  ANNOUNCEMENTS_USAGE_BY_STAFF,
  ANNOUNCEMENTS_USAGE_BY_STUDENT,
  ANNOUNCEMENTS_USAGE_BY_FAMILY,
};

export const USAGE_MODULE_TABLES = {
  ...OVERVIEW_USAGE_TABLES,
  ...PLANNING_USAGE_TABLES,
  ...PORTFOLIO_USAGE_TABLES,
  ...ASSIGNMENTS_USAGE_TABLES,
  ...MESSAGING_USAGE_TABLES,
  ...ANNOUNCEMENTS_USAGE_TABLES,
};

// Table constants for attendance analytics module
export const ATTENDANCE_OVERVIEW = "ATTENDANCE_OVERVIEW";
export const ATTENDANCE_BY_CLASS = "ATTENDANCE_BY_CLASS";
export const ATTENDANCE_BY_GRADE = "ATTENDANCE_BY_GRADE";
export const ATTENDANCE_BY_STUDENT = "ATTENDANCE_BY_STUDENT";

export const ABSENT_STUDENTS_OVERVIEW = "ABSENT_STUDENTS_OVERVIEW";
export const DETAILED_STUDENTS_OVERVIEW = "DETAILED_STUDENTS_OVERVIEW";

export const ABSENT_STUDENTS_BY_CLASS = "ABSENT_STUDENTS_BY_CLASS";
export const DETAILED_STUDENTS_BY_CLASS = "DETAILED_STUDENTS_BY_CLASS";
export const ATTENDANCE_OVERVIEW_BY_CLASS = "ATTENDANCE_OVERVIEW_BY_CLASS";

export const ABSENT_STUDENTS_BY_GRADE = "ABSENT_STUDENTS_BY_GRADE";
export const DETAILED_STUDENTS_BY_GRADE = "DETAILED_STUDENTS_BY_GRADE";
export const ATTENDANCE_OVERVIEW_BY_GRADE = "ATTENDANCE_OVERVIEW_BY_GRADE";

export const DETAILED_ATTENDANCE_BY_STUDENT = "DETAILED_ATTENDANCE_BY_STUDENT";
export const ATTENDANCE_OVERVIEW_BY_STUDENT = "ATTENDANCE_OVERVIEW_BY_STUDENT";
export const CLASS_ATTENDANCE_BY_STUDENT = "CLASS_ATTENDANCE_BY_STUDENT";
export const PERIOD_ATTENDANCE_BY_STUDENT = "PERIOD_ATTENDANCE_BY_STUDENT";

export const ALL_CURRICULUMS = "ALL_CURRICULUMS";

export const TABLE_DEFAULT_COLUMNS = {
  [ENGAGEMENT_ANALYTICS]: {
    [USER_TYPE_ENUM["staff"]]: [
      "staffName",
      "staffID",
      "programmes",
      "displayTitle",
      "systemRole",
      "totalClassesAssigned",
      "lastActive",
      "daysActive",
      "unitPlansCreated",
      "assignmentsCreated",
      "assignmentsAssigned",
      "postsCreated",
      "postsPublished",
      "postsLiked",
      "postsCommentedOn",
      "announcementsCreated",
      "messagesSent",
      "coursesCreated",
      "totalCoursesAssigned",
    ],
    [USER_TYPE_ENUM["parent"]]: [
      "familyMemberName",
      "familyConnectionStatus",
      "familyMembersInvited",
      "familyMembersConnected",
      "associatedStudents",
      "lastActive",
      "daysActive",
      "postsViewed",
      "postsLiked",
      "postsCommentedOn",
      "announcementsReceived",
      "excusalsRaised",
    ],
    [USER_TYPE_ENUM["student"]]: [
      "studentName",
      "gender",
      "programmes",
      "grade",
      "totalClasses",
      "lastActive",
      "daysActive",
      "assignmentsAssigned",
      "assignmentsTurnedInOnTime",
      "assignmentsTurnedInLate",
      "assignmentsOverdue",
      "announcementsReceived",
      "postsCreated",
      "postsLiked",
      "postsCommentedOn",
      "messagesSent",
    ],
  },
  [PERFORMANCE_ANALYTICS]: {
    [YEARGROUP_PERFORMANCE]: {
      [OVERALL_PERFORMANCE_BY_YEARGROUP]: {
        [CURRICULUM_TYPE_DP]: [
          "grade",
          "yearGroupName",
          "totalStudents",
          "averageIbDpTotal",
          "averageIbGrade",
          "averageScore",
          "studentsWithIBDPLessThan24",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "grade",
          "yearGroupName",
          "totalStudents",
          "averageScore",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "grade",
          "yearGroupName",
          "totalStudents",
          "meanIbMypTotal",
          "averageIbGrade",
          "averageScore",
          "studentsWithIBMYPLessThan27",
        ],
      },
      [STUDENT_OVERALL_PERFORMANCE_BY_YEARGOUP]: {
        [CURRICULUM_TYPE_DP]: [
          "studentName",
          "studentUID",
          "coursesEnrolled",
          "ibDpTotal",
          "averageIbGrade",
          "averageScore",
          "subjectsWithIbGradeLessThan4",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "studentName",
          "studentUID",
          "coursesEnrolled",
          "averageScore",
          "subjectsWithOverallScoreLessThan40",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "studentName",
          "studentUID",
          "coursesEnrolled",
          "ibMypTotal",
          "averageIbGrade",
          "averageScore",
          "subjectsWithIbGradeLessThan4",
        ],
      },
      [STUDENT_SUBJECTWISE_PERFORMANCE_BY_YEARGROUP]: {
        [CURRICULUM_TYPE_DP]: [
          "studentName",
          "studentUID",
          "subjects",
          "ibGrade",
          "overallScore",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "studentName",
          "studentUID",
          "subjects",
          "overallScore",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "studentName",
          "studentUID",
          "subjects",
          "criteriaA",
          "criteriaB",
          "criteriaC",
          "criteriaD",
          "criteriaAMeanGrade",
          "criteriaBMeanGrade",
          "criteriaCMeanGrade",
          "criteriaDMeanGrade",
          "ibGrade",
          "overallScore",
        ],
      },
      [SUBJECT_PERFORMANCE_BY_YEARGROUP]: {
        [CURRICULUM_TYPE_DP]: [
          "subjectName",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
          "averageFinalGrade",
          "gradeScale",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "subjectName",
          "totalStudents",
          "averageScore",
          "studentsWithOverallScoreLessThan40",
          "averageFinalGrade",
          "gradeScale",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "subjectName",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
          "averageFinalGrade",
          "gradeScale",
        ],
      },
    },
    [SUBJECT_PERFORMANCE]: {
      [OVERALL_PERFORMANCE_BY_SUBJECT]: {
        [CURRICULUM_TYPE_DP]: [
          "subjectName",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "subjectName",
          "totalStudents",
          "averageScore",
          "studentsWithOverallScoreLessThan40",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "subjectName",
          "totalStudents",
          "criteriaAMeanGrade",
          "criteriaBMeanGrade",
          "criteriaCMeanGrade",
          "criteriaDMeanGrade",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
        ],
      },
      [STUDENT_PERFORMANCE_BY_SUBJECT]: {
        [CURRICULUM_TYPE_DP]: [
          "studentName",
          "studentUID",
          "categoryScores",
          "categoryIbGrade",
          "ibGrade",
          "overallScore",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "studentName",
          "studentUID",
          "categoryScores",
          "overallScore",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "studentName",
          "studentUID",
          "criteriaA",
          "criteriaB",
          "criteriaC",
          "criteriaD",
          "criteriaAMeanGrade",
          "criteriaBMeanGrade",
          "criteriaCMeanGrade",
          "criteriaDMeanGrade",
          "ibGrade",
          "overallScore",
        ],
      },
      [CLASS_PERFORMANCE_BY_SUBJECT]: {
        [CURRICULUM_TYPE_DP]: [
          "className",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
          "averageFinalGrade",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "className",
          "subjectName",
          "totalStudents",
          "averageScore",
          "studentsWithOverallScoreLessThan40",
          "averageFinalGrade",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "className",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
          "averageFinalGrade",
        ],
      },
    },
    [LEARNING_COURSE_PERFORMANCE]: {
      [OVERALL_PERFORMANCE_BY_LEARNING_COURSE]: {
        [CURRICULUM_TYPE_DP]: [
          "learningCourse",
          "totalClasses",
          "totalStudents",
          "averageScore",
          "staffMembers",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "learningCourse",
          "totalClasses",
          "totalStudents",
          "averageScore",
          "staffMembers",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "learningCourse",
          "totalClasses",
          "totalStudents",
          "averageScore",
          "staffMembers",
        ],
      },
      [STUDENT_PERFORMANCE_BY_LEARNING_COURSE]: {
        [CURRICULUM_TYPE_DP]: [
          "studentName",
          "finalGrade",
          "categoryGrade",
          "overallScore",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "studentName",
          "finalGrade",
          "categoryGrade",
          "overallScore",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "studentName",
          "finalGrade",
          "categoryGrade",
          "overallScore",
        ],
      },
      [CLASS_PERFORMANCE_BY_LEARNING_COURSE]: {
        [CURRICULUM_TYPE_DP]: [
          "className",
          "totalStudents",
          "averageScore",
          "staffMembers",
          "averageFinalGrade",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "className",
          "totalStudents",
          "averageScore",
          "staffMembers",
          "averageFinalGrade",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "className",
          "totalStudents",
          "averageScore",
          "staffMembers",
          "averageFinalGrade",
        ],
      },
    },
    [CLASS_PERFORMANCE]: {
      [OVERALL_PERFORMANCE_BY_CLASS]: {
        [CURRICULUM_TYPE_DP]: [
          "className",
          "subjects",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "className",
          "grade",
          "subjects",
          "totalStudents",
          "averageScore",
          "studentsWithOverallScoreLessThan40",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "className",
          "totalStudents",
          "criteriaAMeanGrade",
          "criteriaBMeanGrade",
          "criteriaCMeanGrade",
          "criteriaDMeanGrade",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
        ],
      },
      [STUDENT_PERFORMANCE_BY_CLASS]: {
        [CURRICULUM_TYPE_DP]: [
          "studentName",
          "studentUID",
          "categoryScores",
          "categoryIbGrade",
          "ibGrade",
          "overallScore",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "studentName",
          "studentUID",
          "categoryScores",
          "overallScore",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "studentName",
          "studentUID",
          "criteriaA",
          "criteriaB",
          "criteriaC",
          "criteriaD",
          "criteriaAMeanGrade",
          "criteriaBMeanGrade",
          "criteriaCMeanGrade",
          "criteriaDMeanGrade",
          "ibGrade",
          "overallScore",
        ],
      },
      [ASSIGNMENT_PERFORMANCE_BY_CLASS]: {
        [CURRICULUM_TYPE_DP]: [
          "assignmentName",
          "assignedTo",
          "averageScore",
          "normalisedScore",
          "averageIbGrade",
          "submissionStatus",
          "dueDate",
          ...getV2SpecificAssignmentTableColumnIds(),
        ],
        [CURRICULUM_TYPE_UBD]: [
          "assignmentName",
          "assignedTo",
          "averageScore",
          "normalisedScore",
          "submissionStatus",
          "dueDate",
          ...getV2SpecificAssignmentTableColumnIds(),
        ],
        [CURRICULUM_TYPE_MYP]: [
          "assignmentName",
          "assignedTo",
          "submissionStatus",
          "dueDate",
          "criteriaAMeanGrade",
          "criteriaBMeanGrade",
          "criteriaCMeanGrade",
          "criteriaDMeanGrade",
          ...getV2SpecificAssignmentTableColumnIds(),
        ],
      },
    },
    [STAFF_PERFORMANCE]: {
      [OVERALL_PERFORMANCE_BY_STAFF]: {
        [CURRICULUM_TYPE_DP]: ["staffName", "totalClasses", "totalStudents"],
        [CURRICULUM_TYPE_UBD]: ["staffName", "totalClasses", "totalStudents"],
        [CURRICULUM_TYPE_MYP]: ["staffName", "totalClasses", "totalStudents"],
      },
      [CLASS_PERFORMANCE_BY_STAFF]: {
        [CURRICULUM_TYPE_DP]: [
          "className",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "className",
          "grade",
          "subjects",
          "totalStudents",
          "averageScore",
          "studentsWithOverallScoreLessThan40",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "className",
          "totalStudents",
          "averageIbGrade",
          "averageScore",
          "studentsWithIbGradeLessThan4",
        ],
      },
    },
    [STUDENT_PERFORMANCE]: {
      [OVERALL_PERFORMANCE_BY_STUDENT]: {
        [CURRICULUM_TYPE_DP]: [
          "studentName",
          "studentUID",
          "grade",
          "coursesEnrolled",
          "ibDpTotal",
          "averageIbGrade",
          "averageScore",
          "subjectsWithIbGradeLessThan4",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "studentName",
          "studentUID",
          "grade",
          "subjectEnrolled",
          "learningCoursesEnrolled",
          "coursesEnrolled",
          "averageScore",
          "subjectsWithOverallScoreLessThan40",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "studentName",
          "studentUID",
          "grade",
          "coursesEnrolled",
          "ibMypTotal",
          "averageIbGrade",
          "averageScore",
          "subjectsWithIbGradeLessThan4",
        ],
      },
      [SUBJECT_PERFORMANCE_BY_STUDENT]: {
        [CURRICULUM_TYPE_DP]: [
          "subjectName",
          "overallScore",
          "ibGrade",
          "finalGrade",
          "gradeScale",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "subjectName",
          "overallScore",
          "finalGrade",
          "gradeScale",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "subjectName",
          "criteriaA",
          "criteriaB",
          "criteriaC",
          "criteriaD",
          "overallScore",
          "ibGrade",
          "finalGrade",
          "gradeScale",
        ],
      },
      [ASSIGNMENT_PERFORMANCE_BY_STUDENT]: {
        [CURRICULUM_TYPE_DP]: [
          "assignmentName",
          "ibGrade",
          "score",
          "normalisedScore",
        ],
        [CURRICULUM_TYPE_UBD]: ["assignmentName", "score", "normalisedScore"],
        [CURRICULUM_TYPE_MYP]: [
          "assignmentName",
          "criteriaA",
          "criteriaB",
          "criteriaC",
          "criteriaD",
        ],
      },
    },
  },
  [BEHAVIOUR_ANALYTICS]: {
    [OVERVIEW_BEHAVIOUR]: {
      [STUDENT_NEGATIVE_NEUTRAL_INCIDENTS_OVERVIEW]: [
        "studentName",
        "studentUID",
        "grade",
        "totalIncidents",
        "behaviourCategory",
      ],
      [STUDENT_POSITIVE_INCIDENTS_OVERVIEW]: [
        "studentName",
        "studentUID",
        "grade",
        "totalIncidents",
        "behaviourCategory",
      ],
    },
    [CATEGORY_BEHAVIOUR]: {
      [INCIDENT_OVERVIEW_BY_CATEGORY]: [
        "categoryOverview",
        "sentiment",
        "totalIncidents",
      ],
      [INCIDENT_DETAILED_BY_CATEGORY]: [
        ...INCIDENT_TABLE_DEFAULT_COLUMNS,
        "studentInvolved",
      ],
    },
    [GRADE_BEHAVIOUR]: {
      [INCIDENT_OVERVIEW_BY_GRADE]: [
        "grade",
        "totalIncidents",
        "behaviourCategory",
      ],
      [INCIDENT_DETAILED_BY_GRADE]: [
        ...INCIDENT_TABLE_DEFAULT_COLUMNS,
        "studentInvolved",
      ],
    },
    [STUDENT_BEHAVIOUR]: {
      [INCIDENT_OVERVIEW_BY_STUDENT]: [
        "studentName",
        "studentUID",
        "grade",
        "totalIncidents",
        "behaviourCategory",
      ],
      [INCIDENT_DETAILED_BY_STUDENT]: INCIDENT_TABLE_DEFAULT_COLUMNS,
    },
  },
  [MODULE_USAGE_ANALYTICS]: {
    [OVERVIEW_USAGE]: {
      [OVERVIEW_USAGE_BY_GRADE]: [
        "grade",
        "programmes",
        "unitPlansCreated",
        "assignmentsAssigned",
        "portfolioPostsCreated",
        // "announcementsCreated",  // Temporarily hiding this column as per the discussion with backend
        "progressReportsCreated",
      ],
      [OVERVIEW_USAGE_BY_LEARNING_COURSE]: [
        "learningCourse",
        "programmes",
        "grade",
        "unitPlansCreated",
        "assignmentsAssigned",
        "portfolioPostsCreated",
        // "announcementsCreated",  // Temporarily hiding this column as per the discussion with backend
      ],
      [OVERVIEW_USAGE_BY_CLASS]: [
        "className",
        "programmes",
        "unitPlansCreated",
        "assignmentsAssigned",
        "portfolioPostsCreated",
        // "announcementsCreated",  // Temporarily hiding this column as per the discussion with backend
      ],
      [OVERVIEW_USAGE_BY_STAFF]: [
        "name",
        "programmes",
        "role",
        "title",
        "unitPlansCreated",
        "assignmentsAssigned",
        "portfolioPostsCreated",
        "announcementsCreated",
        "messagesSent",
      ],
      [OVERVIEW_USAGE_BY_STUDENT]: [
        "name",
        "programmes",
        "assignmentsAssigned",
        "portfolioPostsCreated",
        "messagesSent",
      ],
      [OVERVIEW_USAGE_BY_FAMILY]: ["name", "programmes", "messagesSent"],
    },
    [PLANNING_USAGE]: {
      [PLANNING_USAGE_BY_GRADE]: {
        [CURRICULUM_TYPE_PYP]: [
          "grade",
          "programmes",
          "unitPlansCreated",
          "transdisciplinaryUnitsCreated",
          "subjectSpecificUnitsCreated",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "grade",
          "programmes",
          "unitPlansCreated",
          "subjectSpecificUnitsCreated",
          "interdisciplinaryUnitsCreated",
        ],
        [CURRICULUM_TYPE_DP]: ["grade", "programmes", "unitPlansCreated"],
        [CURRICULUM_TYPE_UBD]: [
          "grade",
          "programmes",
          "unitPlansCreated",
          "subjectSpecificUnitsCreated",
          "interdisciplinaryUnitsCreated",
        ],
        [ALL_CURRICULUMS]: ["grade", "programmes", "unitPlansCreated"],
      },
      [PLANNING_USAGE_BY_CLASS]: {
        [CURRICULUM_TYPE_PYP]: [
          "className",
          "grade",
          "programmes",
          "unitPlansCreated",
          "transdisciplinaryUnitsCreated",
          "subjectSpecificUnitsCreated",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "className",
          "grade",
          "programmes",
          "unitPlansCreated",
          "subjectSpecificUnitsCreated",
          "interdisciplinaryUnitsCreated",
        ],
        [CURRICULUM_TYPE_DP]: [
          "className",
          "grade",
          "programmes",
          "unitPlansCreated",
        ],
        [CURRICULUM_TYPE_UBD]: [
          "className",
          "grade",
          "programmes",
          "unitPlansCreated",
          "subjectSpecificUnitsCreated",
          "interdisciplinaryUnitsCreated",
        ],
        [ALL_CURRICULUMS]: [
          "className",
          "grade",
          "programmes",
          "unitPlansCreated",
        ],
      },
      [PLANNING_USAGE_BY_STAFF]: {
        [CURRICULUM_TYPE_PYP]: [
          "name",
          "uid",
          "programmes",
          "unitPlansCreated",
          "transdisciplinaryUnitsCreated",
          "subjectSpecificUnitsCreated",
        ],
        [CURRICULUM_TYPE_MYP]: [
          "name",
          "uid",
          "programmes",
          "unitPlansCreated",
          "subjectSpecificUnitsCreated",
          "interdisciplinaryUnitsCreated",
        ],
        [CURRICULUM_TYPE_DP]: ["name", "uid", "programmes", "unitPlansCreated"],
        [CURRICULUM_TYPE_UBD]: [
          "name",
          "uid",
          "programmes",
          "unitPlansCreated",
          "subjectSpecificUnitsCreated",
          "interdisciplinaryUnitsCreated",
        ],
        [ALL_CURRICULUMS]: ["name", "uid", "programmes", "unitPlansCreated"],
      },
      [PLANNING_USAGE_BY_LEARNING_COURSE]: {
        [CURRICULUM_TYPE_PYP]: PLANNING_USAGE_LEARNING_COURSE_DEFAULT_COLUMNS,
        [CURRICULUM_TYPE_MYP]: PLANNING_USAGE_LEARNING_COURSE_DEFAULT_COLUMNS,
        [CURRICULUM_TYPE_DP]: PLANNING_USAGE_LEARNING_COURSE_DEFAULT_COLUMNS,
        [CURRICULUM_TYPE_UBD]: PLANNING_USAGE_LEARNING_COURSE_DEFAULT_COLUMNS,
        [ALL_CURRICULUMS]: PLANNING_USAGE_LEARNING_COURSE_DEFAULT_COLUMNS,
      },
    },
    [PORTFOLIO_USAGE]: {
      [PORTFOLIO_USAGE_BY_GRADE]: [
        "grade",
        "programmes",
        "totalPostsCreated",
        "postsPublished",
        "postsScheduled",
        "postsInDraft",
        "postsCreatedByStaff",
        "postsCreatedByStudents",
      ],
      [PORTFOLIO_USAGE_BY_CLASS]: [
        "className",
        "programmes",
        "grade",
        "totalPostsCreated",
        "postsPublished",
        "postsScheduled",
        "postsInDraft",
        "postsCreatedByStaff",
        "postsCreatedByStudents",
      ],
      [PORTFOLIO_USAGE_BY_STAFF]: [
        "name",
        "uid",
        "programmes",
        "totalPostsCreated",
        "postsPublished",
        "postsScheduled",
        "postsInDraft",
        "postsLiked",
        "postsCommentedOn",
      ],
      [PORTFOLIO_USAGE_BY_STUDENT]: [
        "name",
        "uid",
        "programmes",
        "grade",
        "totalPostsCreated",
        "postsPublished",
        "postsScheduled",
        "postsInDraft",
        "postsLiked",
        "postsCommentedOn",
      ],
      [PORTFOLIO_USAGE_BY_LEARNING_COURSE]: [
        "learningCourse",
        "programmes",
        "grade",
        "totalPostsCreated",
        "postsPublished",
        "postsScheduled",
        "postsInDraft",
        "postsCreatedByStaff",
        "postsCreatedByStudents",
      ],
    },
    [ASSIGNMENTS_USAGE]: {
      [ASSIGNMENTS_USAGE_BY_GRADE]: [
        "grade",
        "programmes",
        "assignmentsAssigned",
        "late",
        "overdue",
        "pending",
        "notSubmitted",
        "onTime",
      ],
      [ASSIGNMENTS_USAGE_BY_CLASS]: [
        "className",
        "programmes",
        "assignmentsAssigned",
        "late",
        "overdue",
        "pending",
        "notSubmitted",
        "onTime",
      ],
      [ASSIGNMENTS_USAGE_BY_STAFF]: [
        "name",
        "uid",
        "programmes",
        "assignmentsAssigned",
        "assignmentsReviewed",
        "assignmentsToReview",
      ],
      [ASSIGNMENTS_USAGE_BY_STUDENT]: [
        "name",
        "uid",
        "programmes",
        "grade",
        "assignmentsAssigned",
        "pending",
        "overdue",
        "notSubmitted",
        "late",
        "onTime",
      ],
      [ASSIGNMENTS_USAGE_BY_LEARNING_COURSE]: [
        "learningCourse",
        "programmes",
        "grade",
        "assignmentsAssigned",
        "pending",
        "overdue",
        "submitted",
        "late",
        "onTime",
      ],
    },
    [MESSAGING_USAGE]: {
      [MESSAGING_USAGE_BY_STAFF]: [
        "name",
        "uid",
        "messagesSent",
        "flaggedMessages",
      ],
      [MESSAGING_USAGE_BY_STUDENT]: [
        "name",
        "uid",
        "messagesSent",
        "flaggedMessages",
      ],
      [MESSAGING_USAGE_BY_FAMILY]: [
        "name",
        "uid",
        "messagesSent",
        "flaggedMessages",
      ],
    },
    [ANNOUNCEMENTS_USAGE]: {
      [ANNOUNCEMENTS_USAGE_BY_GRADE]: [],
      [ANNOUNCEMENTS_USAGE_BY_CLASS]: [],
      [ANNOUNCEMENTS_USAGE_BY_STAFF]: [],
      [ANNOUNCEMENTS_USAGE_BY_STUDENT]: [],
      [ANNOUNCEMENTS_USAGE_BY_FAMILY]: [],
    },
  },
  [ATTENDANCE_ANALYTICS]: {
    [ATTENDANCE_OVERVIEW]: {
      [ABSENT_STUDENTS_OVERVIEW]: [
        "studentName",
        "uid",
        "programme",
        "grade",
        "daysAbsent",
        "periodsAbsent",
        "attendanceTier",
        "overallPresence",
        "overallPresenceYtd",
        "markedDays",
        "markedPeriods",
      ],
      [DETAILED_STUDENTS_OVERVIEW]: [
        "studentName",
        "uid",
        "programme",
        "homeroomAdvisor",
        "attendanceTier",
        "grade",
        "overallPresence",
        "overallPresenceYtd",
        "attendanceCategory",
        "markedDays",
        "markedPeriods",
      ],
    },
    [ATTENDANCE_BY_CLASS]: {
      [ABSENT_STUDENTS_BY_CLASS]: [
        "studentName",
        "uid",
        "programme",
        "grade",
        "daysAbsent",
        "periodsAbsent",
        "attendanceTier",
        "overallPresence",
        "overallPresenceYtd",
        "markedDays",
        "markedPeriods",
      ],
      [DETAILED_STUDENTS_BY_CLASS]: [
        "studentName",
        "uid",
        "programme",
        "homeroomAdvisor",
        "attendanceTier",
        "grade",
        "overallPresence",
        "overallPresenceYtd",
        "attendanceCategory",
        "markedDays",
        "markedPeriods",
      ],
      [ATTENDANCE_OVERVIEW_BY_CLASS]: [
        "className",
        "grade",
        "totalStudents",
        "markingRate",
        "overallPresence",
        "overallPresenceYtd",
        "chronicAbsentees",
      ],
    },
    [ATTENDANCE_BY_GRADE]: {
      [ABSENT_STUDENTS_BY_GRADE]: [
        "studentName",
        "uid",
        "programme",
        "grade",
        "daysAbsent",
        "periodsAbsent",
        "attendanceTier",
        "overallPresence",
        "overallPresenceYtd",
        "markedDays",
        "markedPeriods",
      ],
      [DETAILED_STUDENTS_BY_GRADE]: [
        "studentName",
        "uid",
        "programme",
        "homeroomAdvisor",
        "attendanceTier",
        "grade",
        "overallPresence",
        "overallPresenceYtd",
        "attendanceCategory",
        "markedDays",
        "markedPeriods",
      ],
      [ATTENDANCE_OVERVIEW_BY_GRADE]: [
        "gradeName",
        "totalStudents",
        "overallPresence",
        "overallPresenceYtd",
        "chronicAbsentees",
        "totalAbsentees",
        "excusalsRaised",
        "markingRate",
      ],
    },
    [ATTENDANCE_BY_STUDENT]: {
      [DETAILED_ATTENDANCE_BY_STUDENT]: [
        "date",
        "periods",
        "dailyAttendance",
        "attendanceCode",
        "daily",
        "comment",
        "attendancePeriod",
      ],
      [ATTENDANCE_OVERVIEW_BY_STUDENT]: [
        "studentName",
        "uid",
        "grade",
        "homeroomAdvisor",
        "attendanceTier",
        "overallPresence",
        "overallPresenceYtd",
        "absentStudent",
        "totalExcusals",
        "markedDays",
        "markedPeriods",
      ],
      [CLASS_ATTENDANCE_BY_STUDENT]: [
        "className",
        "overallPresence",
        "attendanceCategory",
      ],
      [PERIOD_ATTENDANCE_BY_STUDENT]: [
        "period",
        "overallPresence",
        "attendanceCategory",
      ],
    },
  },
};

export const TABLE_CONFIG_PERMS = {
  [ENGAGEMENT_ANALYTICS]: "Analytics:EngagementAnalyticsTableColumns",
  [PERFORMANCE_ANALYTICS]: {
    [YEARGROUP_PERFORMANCE]: "Analytics:GradePerformanceTableColumns",
    [SUBJECT_PERFORMANCE]: "Analytics:SubjectPerformanceTableColumns",
    [CLASS_PERFORMANCE]: "Analytics:ClassPerformanceTableColumns",
    [STAFF_PERFORMANCE]: "Analytics:StaffPerformanceTableColumns",
    [STUDENT_PERFORMANCE]: "Analytics:StudentPerformanceTableColumns",
    [LEARNING_COURSE_PERFORMANCE]:
      "Analytics:LearningCoursePerformanceTableColumns",
  },
  [BEHAVIOUR_ANALYTICS]: {
    [OVERVIEW_BEHAVIOUR]: "Analytics:OverviewBehaviourTableColumns",
    [CATEGORY_BEHAVIOUR]: "Analytics:CategoryBehaviourTableColumns",
    [GRADE_BEHAVIOUR]: "Analytics:GradeBehaviourTableColumns",
    [STUDENT_BEHAVIOUR]: "Analytics:StudentBehaviourTableColumns",
  },
  [MODULE_USAGE_ANALYTICS]: {
    [OVERVIEW_USAGE]: "Analytics:OverviewUsageTableColumns",
    [PLANNING_USAGE]: "Analytics:PlanningUsageTableColumns",
    [PORTFOLIO_USAGE]: "Analytics:PortfolioUsageTableColumns",
    [ASSIGNMENTS_USAGE]: "Analytics:AssignmentsUsageTableColumns",
    [MESSAGING_USAGE]: "Analytics:MessagingUsageTableColumns",
    [ANNOUNCEMENTS_USAGE]: "Analytics:AnnouncementsUsageTableColumns",
  },
  [ATTENDANCE_ANALYTICS]: {
    [ATTENDANCE_OVERVIEW]: "Analytics:AttendanceOverviewTableColumns",
    [ATTENDANCE_BY_CLASS]: "Analytics:AttendanceByClassTableColumns",
    [ATTENDANCE_BY_GRADE]: "Analytics:AttendanceByGradeTableColumns",
    [ATTENDANCE_BY_STUDENT]: "Analytics:AttendanceByStudentTableColumns",
  },
};

export const DYNAMIC_COLUMNS_INSERT_INDEX_VALUE = {
  [STUDENT_PERFORMANCE_BY_SUBJECT]: 5,
  [STUDENT_PERFORMANCE_BY_CLASS]: 5,
  [STUDENT_NEGATIVE_NEUTRAL_INCIDENTS_OVERVIEW]: 4,
  [STUDENT_POSITIVE_INCIDENTS_OVERVIEW]: 4,
  [INCIDENT_OVERVIEW_BY_GRADE]: 2,
  [INCIDENT_OVERVIEW_BY_STUDENT]: 4,
};

export const DYNAMIC_COLUMNS_VALUE_TYPES = {
  [CURRICULUM_TYPE_DP]: ["IB_DP_GRADE", "SCORE"],
  [CURRICULUM_TYPE_UBD]: ["SCORE"],
};

export const DYNAMIC_COLUMNS_VALUE_TYPES_VARIABLES = {
  IB_DP_GRADE: {
    subText: "toddleAnalytics:ib_grade",
    configurationId: "categoryIbGrade",
    configurationLabel: "toddleAnalytics:category_ib_grade",
    colorCodingRanges: [
      {
        low: 0,
        high: 3,
      },
      {
        low: 3,
        high: 5,
      },
      {
        low: 5,
        high: 7,
      },
    ],
  },
  SCORE: {
    subText: {
      PERCENTAGE: "toddleAnalytics:score_with_percent",
      WEIGHT: "toddleAnalytics:score",
    },
    configurationId: "categoryScores",
    configurationLabel: "toddleAnalytics:category_scores",
    colorCodingRanges: [
      {
        low: 0,
        high: 40,
      },
      {
        low: 40,
        high: 80,
      },
      {
        low: 80,
        high: 100,
      },
    ],
  },
};

export const COLOR_BUCKETS = [
  [
    {
      background: "var(--surface-semantic-error)",
      color: "var(--tag-foreground-pink)",
    },
  ],
  [],
  [],
];

const DEFAULT_COLORS_VALUE_RANGE = {
  ibGrade: [
    {
      low: 0,
      high: 3,
    },
    {
      low: 3,
      high: 6,
    },
    {
      low: 6,
      high: 7,
    },
  ],
  ibDpTotal: [
    {
      low: 0,
      high: 23,
    },
    {
      low: 23,
      high: 34,
    },
    {
      low: 34,
      high: 42,
    },
  ],
  ibMypTotal: [
    {
      low: 0,
      high: 28,
    },
    {
      low: 28,
      high: 41,
    },
    {
      low: 41,
      high: 56,
    },
  ],
  score: [
    {
      low: 0,
      high: 40,
    },
    {
      low: 40,
      high: 70,
    },
    {
      low: 70,
      high: 100,
    },
  ],
};

export const COLORS_VALUE_RANGE = {
  ibGrade: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  averageIbGrade: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaAMeanGrade: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaBMeanGrade: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaCMeanGrade: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaDMeanGrade: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaA: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaB: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaC: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  criteriaD: DEFAULT_COLORS_VALUE_RANGE["ibGrade"],
  ibDpTotal: DEFAULT_COLORS_VALUE_RANGE["ibDpTotal"],
  ibMypTotal: DEFAULT_COLORS_VALUE_RANGE["ibMypTotal"],
  score: DEFAULT_COLORS_VALUE_RANGE["score"],
  averageScore: DEFAULT_COLORS_VALUE_RANGE["score"],
  highestScore: DEFAULT_COLORS_VALUE_RANGE["score"],
  median: DEFAULT_COLORS_VALUE_RANGE["score"],
  lowestScore: DEFAULT_COLORS_VALUE_RANGE["score"],
  normalisedScore: DEFAULT_COLORS_VALUE_RANGE["score"],
  overallScore: DEFAULT_COLORS_VALUE_RANGE["score"],
};

export const COLUMN_ID_THRESHOLD_PERM_MAPPING = {
  ibGrade: IB_GRADE_THRESHOLD_CONFIG,
  averageIbGrade: IB_GRADE_THRESHOLD_CONFIG,
  criteriaAMeanGrade: CRITERIA_GRADE_THRESHOLD_CONFIG,
  criteriaBMeanGrade: CRITERIA_GRADE_THRESHOLD_CONFIG,
  criteriaCMeanGrade: CRITERIA_GRADE_THRESHOLD_CONFIG,
  criteriaDMeanGrade: CRITERIA_GRADE_THRESHOLD_CONFIG,
  criteriaA: CRITERIA_GRADE_THRESHOLD_CONFIG,
  criteriaB: CRITERIA_GRADE_THRESHOLD_CONFIG,
  criteriaC: CRITERIA_GRADE_THRESHOLD_CONFIG,
  criteriaD: CRITERIA_GRADE_THRESHOLD_CONFIG,
  ibDpTotal: IBDP_TOTAL_THRESHOLD_CONFIG,
  ibMypTotal: IBMYP_TOTAL_THRESHOLD_CONFIG,
  score: SCORE_THRESHOLD_CONFIG,
  averageScore: SCORE_THRESHOLD_CONFIG,
  highestScore: SCORE_THRESHOLD_CONFIG,
  median: SCORE_THRESHOLD_CONFIG,
  lowestScore: SCORE_THRESHOLD_CONFIG,
  normalisedScore: SCORE_THRESHOLD_CONFIG,
  overallScore: SCORE_THRESHOLD_CONFIG,
};

export const DEFAULT_TABLE_COLUMN_WIDTH = "160px";
export const DEFAULT_TABLE_FIRST_COLUMN_WIDTH = "288px";
export const DEFAULT_MODULE_USAGE_TABLE_COLUMN_WIDTH = "160px";

export const TABLES_PRIMARY_COLUMN_STYLE = {
  color: "var(--text-semantic-info)",
};

export const MULTIGRADING_COLUMN_CONSTANTS = {
  [OVERALL_PERFORMANCE_BY_YEARGROUP]: [
    "averageIbDpTotal",
    "meanIbMypTotal",
    "averageIbGrade",
    "averageScore",
    "studentsWithIBDPLessThan24",
    "studentsWithIBMYPLessThan27",
  ],
  [STUDENT_OVERALL_PERFORMANCE_BY_YEARGOUP]: [
    "ibDpTotal",
    "ibMypTotal",
    "averageIbGrade",
    "averageScore",
    "subjectsWithIbGradeLessThan4",
    "subjectsWithOverallScoreLessThan40",
  ],
  [SUBJECT_PERFORMANCE_BY_YEARGROUP]: [
    "averageIbGrade",
    "averageScore",
    "studentsWithIbGradeLessThan4",
    "studentsWithOverallScoreLessThan40",
    "ibGradeMedian",
    "ibGrade25thPercentile",
    "ibGrade75thPercentile",
    "ibGradeHighest",
    "ibGradeLowest",
    "scoreMedian",
    "score25thPercentile",
    "score75thPercentile",
    "scoreHighest",
    "scoreLowest",
  ],
  [STUDENT_SUBJECTWISE_PERFORMANCE_BY_YEARGROUP]: [
    "ibGrade",
    "criteriaA",
    "criteriaB",
    "criteriaC",
    "criteriaD",
    "criteriaAMeanGrade",
    "criteriaBMeanGrade",
    "criteriaCMeanGrade",
    "criteriaDMeanGrade",
    "overallScore",
  ],
  [OVERALL_PERFORMANCE_BY_SUBJECT]: [
    "criteriaAMeanGrade",
    "criteriaBMeanGrade",
    "criteriaCMeanGrade",
    "criteriaDMeanGrade",
    "averageIbGrade",
    "averageScore",
    "studentsWithIbGradeLessThan4",
    "studentsWithOverallScoreLessThan40",
    "ibGradeMedian",
    "ibGrade25thPercentile",
    "ibGrade75thPercentile",
    "ibGradeHighest",
    "ibGradeLowest",
    "scoreMedian",
    "score25thPercentile",
    "score75thPercentile",
    "scoreHighest",
    "scoreLowest",
  ],
  [STUDENT_PERFORMANCE_BY_SUBJECT]: [
    "ibGrade",
    "criteriaA",
    "criteriaB",
    "criteriaC",
    "criteriaD",
    "criteriaAMeanGrade",
    "criteriaBMeanGrade",
    "criteriaCMeanGrade",
    "criteriaDMeanGrade",
    "overallScore",
  ],
  [CLASS_PERFORMANCE_BY_SUBJECT]: [
    "averageIbGrade",
    "averageScore",
    "studentsWithIbGradeLessThan4",
    "studentsWithOverallScoreLessThan40",
    "ibGradeMedian",
    "ibGrade25thPercentile",
    "ibGrade75thPercentile",
    "ibGradeHighest",
    "ibGradeLowest",
    "scoreMedian",
    "score25thPercentile",
    "score75thPercentile",
    "scoreHighest",
    "scoreLowest",
  ],
  [OVERALL_PERFORMANCE_BY_CLASS]: [
    "criteriaAMeanGrade",
    "criteriaBMeanGrade",
    "criteriaCMeanGrade",
    "criteriaDMeanGrade",
    "averageIbGrade",
    "averageScore",
    "studentsWithIbGradeLessThan4",
    "studentsWithOverallScoreLessThan40",
    "ibGradeMedian",
    "ibGrade25thPercentile",
    "ibGrade75thPercentile",
    "ibGradeHighest",
    "ibGradeLowest",
    "scoreMedian",
    "score25thPercentile",
    "score75thPercentile",
    "scoreHighest",
    "scoreLowest",
  ],
  [STUDENT_PERFORMANCE_BY_CLASS]: [
    "ibGrade",
    "criteriaA",
    "criteriaB",
    "criteriaC",
    "criteriaD",
    "criteriaAMeanGrade",
    "criteriaBMeanGrade",
    "criteriaCMeanGrade",
    "criteriaDMeanGrade",
    "overallScore",
  ],
  [CLASS_PERFORMANCE_BY_STAFF]: [
    "averageIbGrade",
    "averageScore",
    "studentsWithIbGradeLessThan4",
    "studentsWithOverallScoreLessThan40",
  ],
  [OVERALL_PERFORMANCE_BY_STUDENT]: [
    "ibDpTotal",
    "averageIbGrade",
    "ibMypTotal",
    "averageScore",
    "subjectsWithIbGradeLessThan4",
    "subjectsWithOverallScoreLessThan40",
  ],
  [SUBJECT_PERFORMANCE_BY_STUDENT]: [
    "ibGrade",
    "criteriaA",
    "criteriaB",
    "criteriaC",
    "criteriaD",
    "overallScore",
  ],
};
